import storage from 'good-storage'
import {
  SET_MENUS,
  SET_USER_INFO,
  SET_MENU_URL,
  CLEAR_USER_INFO,
} from 'config/mutation-types/user'

const user = {
  namespaced: true,
  state: {
    userInfo: storage.get('userInfo') || {},
    menus: storage.get('userMenus') || [],
    menuUrl: storage.get('menuUrl') || [],
  },
  mutations: {
    [SET_USER_INFO](state, token) {
      state.userInfo = token
    },
    [SET_MENUS](state, menus) {
      state.menus = menus
    },
    [SET_MENU_URL](state, menuUrl) {
      state.menuUrl = menuUrl
    },
    [CLEAR_USER_INFO](state) {
      state.userInfo = {}
      state.userMenus = []
      state.menuUrl = []
    },
  },
  getters: {
    menus(state) {
      return state.menus
    },
    username(state) {
      return state.userInfo.username
    },
    token(state) {
      return state.userInfo.token
    },
    // 扁平化menus，点击跳转页面时直接拿到index跳转
    flatMenus(state) {
      const newArr = []
      const flatFn = arr => {
        arr.forEach(item => {
          const { id, name, index, url, pid } = item
          newArr.push({
            id,
            name,
            index,
            url,
            pid,
          })
          if (item.children && item.children.length) {
            flatFn(item.children)
          }
        })
      }
      flatFn(state.menus)
      return newArr
    },
    // 当前页面的路径名字
    menuUrlName(state, { flatMenus }) {
      const menuNameList = []
      for (let i = 0; i < state.menuUrl.length; i++) {
        const menu = state.menuUrl[i]
        for (let j = 0; j < flatMenus.length; j++) {
          const flatMenu = flatMenus[j]
          if (menu === flatMenu.index) {
            const equalMenuName = menuNameList.filter(
              item => item.breadcrumbName === flatMenu.name,
            )
            // 处理一下两个menuName一样的情况
            if (equalMenuName.length) {
              menuNameList.push({ breadcrumbName: flatMenu.name + ' ' })
            } else {
              menuNameList.push({ breadcrumbName: flatMenu.name })
            }
          }
        }
      }
      return menuNameList
    },
  },
  actions: {},
}

export default user
